<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Csk2xA/tc-custom/9781909166417.jpg?1704761579396" alt="This image is the cover for the book Furies and Fireflies over Korea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Furies and Fireflies over Korea
      </h1>
      <p class="bookDescription body article font2">
        <b>The historian and author details the exploits of British and Australian pilots during the Korean War.</b><br/><br/> With the outbreak of the Korean War, the UN Security Council called on its members to act and 16 nations did, with Britain sending aircraft carriers such as <i>HMS Truimph</i>, from which piston-engined Sea Fury fighters and Fairey Firefly fighter-bombers operated.<br/><br/> This is the story of the British and Australian Fleet Air Arm pilots and their missions over hostile territory, missions carried out with distinction and honor.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Graham A. Thomas
      </h2>
      
      <p class="authorDescription body article">Graham A Thomas is an author and a historian.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d1f66bc